(function(){
  /* 1. Collection SEO description: Read more / Read less */
  document.querySelectorAll('[data-readmore]').forEach(function(wrap){
    var content = wrap.querySelector('[data-readmore-content]');
    var btn = wrap.querySelector('[data-readmore-btn]');
    if(!content || !btn) return;
    if(content.scrollHeight <= content.clientHeight + 10){ btn.style.display='none'; return; }
    btn.addEventListener('click', function(){
      var open = wrap.classList.toggle('is-open');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  });

  /* 2. Collection: Load more with stock priority.
     In-stock products remain at the top across appended pages. Sold-out cards are
     buffered and only released after all in-stock pages have been loaded. */
  var lm = document.querySelector('[data-loadmore]');
  var grid = document.querySelector('[data-collection-grid]');
  if(grid){
    var soldOutBuffer = [];
    function isSoldOutCard(card){
      return card && (card.classList.contains('pk-product-card--soldout') || card.getAttribute('data-product-available') === 'false');
    }
    function moveCurrentSoldOutToBuffer(){
      Array.from(grid.querySelectorAll('.pk-product-card')).forEach(function(card){
        if(isSoldOutCard(card)){
          soldOutBuffer.push(card);
          if(card.parentNode === grid) grid.removeChild(card);
        }
      });
    }
    function appendSoldOutBuffer(){
      if(!soldOutBuffer.length) return;
      soldOutBuffer.forEach(function(card){ grid.appendChild(card); });
      soldOutBuffer = [];
    }
    function appendCardsFromGrid(newGrid){
      var addedInStock = 0;
      if(!newGrid) return addedInStock;
      Array.from(newGrid.querySelectorAll('.pk-product-card')).forEach(function(card){
        var clone = document.importNode(card, true);
        if(isSoldOutCard(clone)){
          soldOutBuffer.push(clone);
        }else{
          grid.appendChild(clone);
          addedInStock++;
        }
      });
      return addedInStock;
    }
    function fetchPage(page){
      var url = new URL(window.location.href);
      url.searchParams.set('page', page);
      return fetch(url.toString(), {headers:{'X-Requested-With':'fetch'}})
        .then(function(r){ return r.text(); })
        .then(function(html){ return new DOMParser().parseFromString(html, 'text/html'); });
    }

    moveCurrentSoldOutToBuffer();
    if(!lm){ appendSoldOutBuffer(); }

    if(lm){
      lm.addEventListener('click', function(){
        var next = parseInt(lm.getAttribute('data-next'), 10) || 2;
        var total = parseInt(lm.getAttribute('data-total'), 10) || 1;
        var perClickTarget = 24;
        var maxPagesPerClick = 6;
        var added = 0;
        var fetched = 0;

        lm.disabled = true;
        lm.textContent = 'Loading in-stock products...';

        function step(){
          if(next > total){
            appendSoldOutBuffer();
            lm.style.display = 'none';
            return;
          }
          if(added >= perClickTarget || fetched >= maxPagesPerClick){
            lm.setAttribute('data-next', next);
            lm.disabled = false;
            lm.textContent = added > 0 ? 'Load more products' : 'Load more in-stock products';
            return;
          }
          fetched++;
          return fetchPage(next).then(function(doc){
            var newGrid = doc.querySelector('[data-collection-grid]');
            added += appendCardsFromGrid(newGrid);
            next++;
            return step();
          });
        }

        Promise.resolve(step()).catch(function(){
          lm.disabled = false;
          lm.textContent = 'Load more products';
        });
      });
    }
  }

  /* 3. BCO smart header search: visible search bar, live product/collection results, SKU-friendly redirect. */
  document.querySelectorAll('[data-bco-search]').forEach(function(wrap){
    var form = wrap.querySelector('[data-bco-search-form]');
    var input = wrap.querySelector('[data-bco-search-input]');
    var panel = wrap.querySelector('[data-bco-search-results]');
    if(!form || !input || !panel) return;

    var timer = null;
    var lastData = null;
    var lastProducts = [];

    function escapeHtml(value){
      return String(value || '').replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; });
    }
    function moneyText(product){
      if(product && product.price) return product.price;
      if(product && product.variants && product.variants[0] && product.variants[0].price) return '$' + product.variants[0].price;
      return '';
    }
    function productImage(product){
      if(product && product.image) return product.image;
      if(product && product.featured_image && product.featured_image.url) return product.featured_image.url;
      if(product && product.images && product.images.length) return product.images[0].src || product.images[0];
      return '';
    }
    function productUrl(product){
      if(product && product.url) return product.url;
      if(product && product.handle) return '/products/' + product.handle;
      return '#';
    }
    function collectionHandle(collection){
      if(collection.handle) return collection.handle;
      if(collection.url){
        var match = collection.url.match(/\/collections\/([^/?#]+)/);
        if(match) return match[1];
      }
      return '';
    }
    function closePanel(){ panel.hidden = true; panel.innerHTML = ''; }
    function openPanel(){ panel.hidden = false; }

    function renderPanel(data, collectionProductsHtml){
      var results = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = results.products || [];
      var collections = results.collections || [];
      lastProducts = products;
      var html = '';
      if(collections.length){
        html += '<div class="pk-smart-search__section"><div class="pk-smart-search__title">Matching collections</div><div class="pk-smart-search__chips">';
        collections.slice(0,6).forEach(function(c){
          html += '<a class="pk-smart-search__chip" href="' + escapeHtml(c.url || ('/collections/' + collectionHandle(c))) + '">' + escapeHtml(c.title) + '</a>';
        });
        html += '</div></div>';
      }
      if(products.length){
        html += '<div class="pk-smart-search__section"><div class="pk-smart-search__title">Matching products</div><div class="pk-smart-search__items">';
        products.slice(0,6).forEach(function(p){
          var img = productImage(p);
          html += '<a class="pk-smart-search__item" href="' + escapeHtml(productUrl(p)) + '">';
          html += img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '<span class="pk-smart-search__placeholder"></span>';
          html += '<span><strong>' + escapeHtml(p.title) + '</strong><small>' + escapeHtml(moneyText(p)) + '</small></span></a>';
        });
        html += '</div></div>';
      }
      if(collectionProductsHtml){ html += collectionProductsHtml; }
      if(!html){ html = '<div class="pk-smart-search__empty">No quick matches. Press Search to view full results.</div>'; }
      panel.innerHTML = html + '<a class="pk-smart-search__all" href="/search?q=' + encodeURIComponent(input.value.trim()) + '&type=product%2Ccollection&options%5Bprefix%5D=last">View all results</a>';
      openPanel();
    }

    function renderCollectionProducts(collection, products){
      if(!collection || !products || !products.length) return '';
      var html = '<div class="pk-smart-search__section pk-smart-search__collection-products"><div class="pk-smart-search__title">Popular from ' + escapeHtml(collection.title) + '</div><div class="pk-smart-search__items">';
      products.slice(0,4).forEach(function(p){
        var img = productImage(p);
        html += '<a class="pk-smart-search__item" href="' + escapeHtml(productUrl(p)) + '">';
        html += img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '<span class="pk-smart-search__placeholder"></span>';
        html += '<span><strong>' + escapeHtml(p.title) + '</strong><small>' + escapeHtml(moneyText(p)) + '</small></span></a>';
      });
      html += '</div></div>';
      return html;
    }

    function fetchCollectionProducts(collection){
      var handle = collectionHandle(collection);
      if(!handle) return Promise.resolve('');
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=4', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(json){ return renderCollectionProducts(collection, json && json.products ? json.products : []); })
        .catch(function(){ return ''; });
    }

    function runSearch(q){
      if(q.length < 2){ closePanel(); return; }
      panel.hidden = false;
      panel.innerHTML = '<div class="pk-smart-search__empty">Searching...</div>';
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          lastData = data;
          var results = data && data.resources && data.resources.results ? data.resources.results : {};
          var collections = results.collections || [];
          if(collections.length){
            return fetchCollectionProducts(collections[0]).then(function(extra){ renderPanel(data, extra); });
          }
          renderPanel(data, '');
        })
        .catch(function(){ closePanel(); });
    }

    input.addEventListener('input', function(){
      window.clearTimeout(timer);
      var q = input.value.trim();
      timer = window.setTimeout(function(){ runSearch(q); }, 260);
    });
    input.addEventListener('focus', function(){ if(input.value.trim().length >= 2) runSearch(input.value.trim()); });
    document.addEventListener('click', function(e){ if(!wrap.contains(e.target)) closePanel(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closePanel(); });

    form.addEventListener('submit', function(e){
      var q = input.value.trim();
      var looksLikeItemNumber = /^[A-Za-z0-9][A-Za-z0-9._-]{2,}$/.test(q) && q.indexOf(' ') === -1;
      if(looksLikeItemNumber && lastProducts.length === 1){
        e.preventDefault();
        window.location.href = productUrl(lastProducts[0]);
      }
    });
  });

  /* 3. Product image: gentle zoom (CSS) + click lightbox with prev/next + thumbnail strip */
  var mainImg = document.querySelector('[data-product-main-image]');
  if(mainImg){
    var srcs = [];
    document.querySelectorAll('.pk-thumb[data-large-src]').forEach(function(t){
      var s = t.getAttribute('data-large-src'); if(s && srcs.indexOf(s) === -1) srcs.push(s);
    });
    if(!srcs.length && mainImg.getAttribute('src')) srcs = [mainImg.getAttribute('src')];

    var lb = null, lbImg = null, lbCount = null, lbThumbs = null, idx = 0;
    function thumbSrc(s){ return s.indexOf('width=') > -1 ? s.replace(/width=\d+/, 'width=160') : s; }
    function build(){
      if(lb) return;
      lb = document.createElement('div'); lb.id = 'pk-lightbox';
      lb.innerHTML =
        '<button class="pk-lb-x" aria-label="Close">&times;</button>' +
        '<button class="pk-lb-nav pk-lb-prev" aria-label="Previous">&#8249;</button>' +
        '<div class="pk-lb-stage"><img alt="Product image"></div>' +
        '<button class="pk-lb-nav pk-lb-next" aria-label="Next">&#8250;</button>' +
        '<div class="pk-lb-count"></div>' +
        '<div class="pk-lb-thumbs"></div>';
      document.body.appendChild(lb);
      lbImg = lb.querySelector('.pk-lb-stage img');
      lbCount = lb.querySelector('.pk-lb-count');
      lbThumbs = lb.querySelector('.pk-lb-thumbs');
      lb.addEventListener('click', function(e){ if(e.target === lb || e.target.classList.contains('pk-lb-x')) close(); });
      lb.querySelector('.pk-lb-prev').addEventListener('click', function(e){ e.stopPropagation(); show(idx - 1); });
      lb.querySelector('.pk-lb-next').addEventListener('click', function(e){ e.stopPropagation(); show(idx + 1); });
      document.addEventListener('keydown', function(e){
        if(!lb.classList.contains('on')) return;
        if(e.key === 'Escape') close();
        else if(e.key === 'ArrowLeft') show(idx - 1);
        else if(e.key === 'ArrowRight') show(idx + 1);
      });
      if(srcs.length < 2){
        lb.querySelector('.pk-lb-prev').style.display = 'none';
        lb.querySelector('.pk-lb-next').style.display = 'none';
        lbThumbs.style.display = 'none';
      } else {
        lbThumbs.innerHTML = srcs.map(function(s, i){
          return '<button type="button" class="pk-lb-thumb" data-i="' + i + '"><img src="' + thumbSrc(s) + '" alt="" loading="lazy"></button>';
        }).join('');
        lbThumbs.addEventListener('click', function(e){ var b = e.target.closest('.pk-lb-thumb'); if(b) show(parseInt(b.getAttribute('data-i'), 10)); });
      }
    }
    function show(i){
      if(!srcs.length) return;
      idx = (i + srcs.length) % srcs.length;
      lbImg.src = srcs[idx];
      lbCount.textContent = (idx + 1) + ' / ' + srcs.length;
      if(lbThumbs){ lbThumbs.querySelectorAll('.pk-lb-thumb').forEach(function(t){ t.classList.toggle('is-active', parseInt(t.getAttribute('data-i'),10) === idx); }); }
    }
    function currentIndex(){ var i = srcs.indexOf(mainImg.getAttribute('src')); return i >= 0 ? i : 0; }
    function open(){ build(); show(currentIndex()); lb.classList.add('on'); document.body.style.overflow = 'hidden'; }
    function close(){ if(lb){ lb.classList.remove('on'); document.body.style.overflow = ''; } }
    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', open);
  }
})();
